import PropTypes from 'prop-types';
import '../css/SectionWrapper.css';

function SectionWrapper({ title, children, titleStyle = {}, contentStyle = {} }) {
    return (
        <div className="section-wrapper">
            {title && (
                <h5 className="section-wrapper-title mb-2 ms-3" style={titleStyle}>
                    {title}
                </h5>
            )}

            <div
                className="section-wrapper-content mt-3"
                style={{
                    height: title ? 'auto' : '100%',
                    ...contentStyle,
                }}
            >
                {children}
            </div>
        </div>
    );
}

SectionWrapper.propTypes = {
    title: PropTypes.string,
    children: PropTypes.node.isRequired,
    titleStyle: PropTypes.object,
    contentStyle: PropTypes.object,
};

SectionWrapper.defaultProps = {
    titleStyle: {},
    contentStyle: {},
};

export default SectionWrapper;